import { render, staticRenderFns } from "./ValidatePOs.vue?vue&type=template&id=96beee3c&"
import script from "./ValidatePOs.vue?vue&type=script&lang=js&"
export * from "./ValidatePOs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports